const SearchIcon = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_808_3017)'>
        <path
          d='M20.1669 20.1667L14.3516 14.3513'
          stroke='#003DD4'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path
          d='M9.16732 16.4999C13.2174 16.4999 16.5007 13.2167 16.5007 9.16659C16.5007 5.1165 13.2174 1.83325 9.16732 1.83325C5.11723 1.83325 1.83398 5.1165 1.83398 9.16659C1.83398 13.2167 5.11723 16.4999 9.16732 16.4999Z'
          stroke='#003DD4'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
      </g>
      <defs>
        <clipPath id='clip0_808_3017'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SearchIcon
